import { render } from "./EstimatePage.vue?vue&type=template&id=6a138123&scoped=true"
import script from "./EstimatePage.vue?vue&type=script&lang=js"
export * from "./EstimatePage.vue?vue&type=script&lang=js"

import "./EstimatePage.vue?vue&type=style&index=0&id=6a138123&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a138123"]])

export default __exports__